import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

import { useCustomerDetailsStyles } from './CustomerDetails';
import FleetEdit from './FleetEdit';

const FleetRow = ({ customer }) => {
  const { id, is_fleet_user, fleet_account_name } = customer;
  const classes = useCustomerDetailsStyles();
  const [openFleetEdit, setOpenFleetEdit] = useState(false);

  return (
    <Grid item key={id}>
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        <Grid item xs={1} className={classes.vehicleImage}>
          <div className={classes.w100}>
            <LocalShippingIcon fontSize="large" />
          </div>
        </Grid>
        <Grid item xs className={classes.cardTextContent}>
          {is_fleet_user ? (
            <Typography>
              {fleet_account_name || 'This is a fleet customer'}
            </Typography>
          ) : (
            <Typography>Not a fleet user</Typography>
          )}
        </Grid>
        <Grid item>
          <IconButton size="small" onClick={() => setOpenFleetEdit(true)}>
            <EditIcon />
          </IconButton>
        </Grid>
      </Grid>
      {openFleetEdit && (
        <FleetEdit
          openEdit={openFleetEdit}
          setOpenEdit={setOpenFleetEdit}
          customer={customer}
        />
      )}
    </Grid>
  );
};

export default FleetRow;
